// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.co-btn-fixed {
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 2;
}
.co-btn-img > img {
  max-width: 100%;
  width: 100%;
  object-fit: contain;
  display: block;
}
@media screen and (min-width: 540px) {
  body .marketing .marketing-content .co-btn-fixed {
    width: 10.8rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/marketing/components/base-button/index.less"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;AACF;AAIE;EACE,eAAA;EACA,WAAA;EACA,mBAAA;EACA,cAAA;AAFJ;AAMA;EACC;IAEE,cAAA;EALD;AACF","sourcesContent":[".co-btn-fixed {\n  position: fixed;\n  width: 100%;\n  bottom: 0;\n  z-index: 2;\n}\n\n.co-btn-img {\n\n  & > img {\n    max-width: 100%;\n    width: 100%;\n    object-fit: contain;\n    display: block;\n  }\n}\n\n@media screen and (min-width: 540px) {\n\tbody {\n    .marketing .marketing-content .co-btn-fixed {\n\t\t\twidth: 540px;\n\t\t}\n\t}\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
